import * as React from "react";

const LocationSVG = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 17" fill="none">
      <g mask="url(#mask0_2646_11570)">
        <path
          d="M10 17.5208C9.81944 17.5208 9.64931 17.4896 9.48958 17.4271C9.32986 17.3646 9.17361 17.2708 9.02083 17.1458C8.46528 16.6597 7.86458 16.0903 7.21875 15.4375C6.57292 14.7847 5.97222 14.0833 5.41667 13.3333C4.86111 12.5833 4.40278 11.8021 4.04167 10.9896C3.68056 10.1771 3.5 9.36806 3.5 8.5625C3.5 6.70139 4.11806 5.14236 5.35417 3.88542C6.59028 2.62847 8.13889 2 10 2C11.8472 2 13.3924 2.62847 14.6354 3.88542C15.8785 5.14236 16.5 6.70139 16.5 8.5625C16.5 9.36806 16.316 10.1806 15.9479 11C15.5799 11.8194 15.1215 12.6042 14.5729 13.3542C14.0243 14.1042 13.4271 14.8021 12.7812 15.4479C12.1354 16.0938 11.5347 16.6597 10.9792 17.1458C10.8264 17.2708 10.6701 17.3646 10.5104 17.4271C10.3507 17.4896 10.1806 17.5208 10 17.5208ZM10 10C10.4167 10 10.7708 9.85417 11.0625 9.5625C11.3542 9.27083 11.5 8.91667 11.5 8.5C11.5 8.08333 11.3542 7.72917 11.0625 7.4375C10.7708 7.14583 10.4167 7 10 7C9.58333 7 9.22917 7.14583 8.9375 7.4375C8.64583 7.72917 8.5 8.08333 8.5 8.5C8.5 8.91667 8.64583 9.27083 8.9375 9.5625C9.22917 9.85417 9.58333 10 10 10Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
export default LocationSVG;
